<!--
 * @Description: 
 * @Date: 2021-07-26 13:39:48
-->
<template>
  <div>
    <div
      class="hasPadding"
      :class="[status == 'before' ? 'beHasPadding' : '']"
      style="overflow:scroll;padding-bottom:1.3rem"
      ref="introBox"
    >
      <course-docter-info
        :obj="detailObj"
        :lec-list="lecList"
      ></course-docter-info>
      <course-sign
        :is-sign-in="isSignIn"
        :is-living="true"
        :status="status"
        :detailObj="detailObj"
      ></course-sign>
      <relation-zone
        v-if="channelObj"
        :channel-obj="channelObj"
      ></relation-zone>
      <template v-if="showPayRec">
        <pay-course :courseObj="payObj" v-show="payFlag"></pay-course>
        <rec-course :course-list="recCourseList"></rec-course>
      </template>
      <div
        class="signUp"
        @click="baoming"
        v-show="status == 'before'"
        :class="[isSignUp ? 'already' : '']"
      >
        {{ isSignUp ? '已报名' : '立即报名' }}
      </div>
    </div>
    <div class="signup_cover" style="z-index: 9999;" v-show="cardFlag">
      <div class="sc_div">
        <h1>报名成功</h1>
        <p class="sc_p sc_pb">
          课程开始前10分钟，将会收到开课提醒，记得来上课哦
        </p>
        <p class="sc_pb">
          恭喜您获得一张邀请卡，请在医学V视界公众号查收！每邀请10位好友报名可获得1元红包！
        </p>
        <div class="ikbt" @click="cardFlag = false">我知道啦</div>
      </div>
    </div>
  </div>
</template>
<script>
import CourseDocterInfo from '@/components/Course/CourseDocterInfo.vue';
import RelationZone from '@/components/Course/RelationZone.vue';
import payCourse from '@/components/payCourse.vue';
import recCourse from '@/components/recCourse.vue';
import CourseSign from '@/components/Course/CourseSign.vue';

import {
  live,
  shareCallback,
  course,
  signIn,
  getChannelById
} from '@/api/ajax.js';
// TODO: vux
import { dateFormat } from 'vux';
import { mapState, mapMutations } from 'vuex';
import { setInterval } from 'timers';
import { getZoneName } from '@/Mixin/getZoneName.js';
export default {
  name: 'LivingIntroduce',
  inject: ['livingStore'],
  data() {
    return {
      zone_name: '',
      dfIndex: 0,
      detailObj: {},
      categoriesArr: [],
      isCollection: 0,
      isSignIn: 0,
      isSignUp: 0,
      catalogObj: [],
      channelObj: null,
      status: '',
      showSignCover: false,
      startTime: '',
      loopLiveInter: null,

      scType: 'wx',
      newGift: {},
      newCom: {},
      hasSocket: false,
      examFlag: 0,
      lecList: [],
      subjectIds: [],
      payFlag: false,
      payObj: {},
      restTime: 0,
      recCourseList: [],
      noQue: true, // 是否有签到题  true 没有
      cardFlag: false
    };
  },
  methods: {
    baoming() {
      if (this.isSignUp != 1) {
        live.wxCourseBook({ courseId: this.courseId }).then(res => {
          if (res.data.status == 'error') {
            this.$vux.toast.show({
              text: '报名失败',
              width: '5rem',
              type: 'cancel'
            });
          } else {
            this.isSignUp = 1;
            this.cardFlag = true;
            this.$vux.toast.show({
              text: '报名成功',
              width: '5rem',
              type: 'success'
            });
            if (this.$route.query.visiterId) {
              //邀请卡带来的报名人数
              sa.track('activity', {
                type: 'subject representative',
                action: ' invitation_card_enrol',
                pageUrl: location.href,
                course_id: this.courseId,
                course_name: this.detailObj.courseName,
                client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
                client_phone: this.wxUserInfo.phone || '',
                from: 'wx',
                web_edition: 2
              });
            }

            //点击报名的神策
            sa.track('activity', {
              type: 'subject representative',
              action: ' enrol_user',
              pageUrl: location.href,
              course_id: this.courseId,
              course_name: this.detailObj.courseName,
              client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
              client_phone: this.wxUserInfo.phone || '',
              from: 'wx',
              web_edition: 2
            });
            //神策发送名片的数量
            sa.track('activity', {
              type: 'subject representative',
              action: ' invitation_card',
              pageUrl: location.href,
              course_id: this.courseId,
              course_name: this.detailObj.courseName,
              client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
              client_phone: this.wxUserInfo.phone || '',
              from: 'wx',
              web_edition: 2
            });
          }
        });
        // 人人课代表，有无visiterId都上报
        let obj = {
          userId: this.wxUserInfo.id,
          courseId: this.courseId,
          visiterId: this.$route.query.visiterId || ''
        };
        live.sendRepresentCoursePoster(obj);
      } else {
        this.$vux.toast.show({
          type: 'text',
          text: '请勿重复报名',
          position: 'middle',
          width: '6rem'
        });
      }
    },
    signIn() {
      //签到方法
      let data = {
        courseId: this.courseId
      };
      if (this.status == 'living') {
        if (this.isSignIn) {
          this.$vux.toast.show({
            type: 'text',
            text: '您已签到',
            position: 'middle'
          });
        } else if (this.noQue) {
          this.$vux.toast.show({
            type: 'text',
            text: '当前课程还没有考题',
            position: 'middle',
            width: '6rem'
          });
        } else {
          if (this.restTime >= 60) {
            this.$router.push({
              name: 'signIn',
              params: {
                id: this.courseId
              },
              query: {
                isLiving: 1
              }
            });
          } else {
            this.$vux.toast.show({
              type: 'text',
              text: '听课满一分钟才能签到',
              position: 'middle',
              width: '6rem'
            });
          }
        }
      } else if (this.status == 'before') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '直播尚未开始',
          position: 'middle',
          width: '6rem'
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel',
          text: '直播已结束',
          position: 'middle',
          width: '6rem'
        });
      }
    },
    tabChange(val) {
      //切换tab
      this.dfIndex = val;
    },
    stsign(val) {
      if (this.status == 'living') {
        if (val === true) {
          this.signIn();
        }
      } else if (this.status == 'before') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '直播尚未开始',
          position: 'middle',
          width: '6rem'
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel',
          text: '直播已结束',
          position: 'middle',
          width: '6rem'
        });
      }
    },
    ...mapMutations(['CLOSEGIFTBOX']),
    closeGift() {
      if (this.closeGiftBox == true) {
        this.CLOSEGIFTBOX(false);
      }
    },
    eventTransGiftList(val) {
      this.newGift = val;
    },
    eventTransComList(val) {
      this.newCom = val;
    },
    exam(val) {
      this.examFlag = val;
    },
    // 进入页面看视频计时
    inPageLectureCourse() {
      if (!this.$api.getStorage('giftTime')) {
        let giftTime = 0;
        let time1 = setInterval(() => {
          giftTime += 5;
          this.$api.setStorage('giftTime', giftTime);
        }, 5000);
      } else {
        let giftTime = this.$api.getStorage('giftTime');
        let time2 = setInterval(() => {
          giftTime += 5;
          this.$api.setStorage('giftTime', giftTime);
        }, 5000);
      }
    },
    showCover() {
      this.showSignCover = true;
    },
    hideCover() {
      this.hideCover = false;
    },
    eventCollection(val) {
      this.isCollection = val;
    },
    detailTime2() {
      if (
        new Date().getTime() <
        this.detailObj.liveStartTime - 10 * 60 * 1000
      ) {
        this.status = 'before'; // 直播开始前和结束后切换到课程介绍，直播中切换到提问区
        this.dfIndex = 1;
      } else if (
        new Date().getTime() + 10 * 60 * 1000 >= this.detailObj.liveStartTime &&
        new Date().getTime() < this.detailObj.liveEndTime
      ) {
        this.status = 'living';
        this.dfIndex = 0;
      } else {
        this.status = 'after';
        this.dfIndex = 1;
      }
      this.startTime = dateFormat(
        this.detailObj.liveStartTime,
        'YYYY-MM-DD HH:mm:ss'
      );
    },
    detailTime() {
      if (
        new Date().getTime() <
        this.detailObj.liveStartTime - 10 * 60 * 1000
      ) {
        this.status = 'before';
      } else if (
        new Date().getTime() + 10 * 60 * 1000 >= this.detailObj.liveStartTime &&
        new Date().getTime() < this.detailObj.liveEndTime
      ) {
        this.status = 'living';
      } else {
        this.status = 'after';
      }
      this.startTime = dateFormat(
        this.detailObj.liveStartTime,
        'YYYY-MM-DD HH:mm:ss'
      );
    },
    getDetail() {
      let isShequn = this.$route.query.shequn;
      let isShare = this.$route.query.shareFlag;
      let sourceFrom = this.$route.query.sourceFrom;
      let data = {
        id: this.courseId,
        courseId: this.courseId
      };
      // 获取签到题
      signIn.questions(data).then(res => {
        this.noQue = res.data.data.length ? false : true;
      });
      // 推荐课程 与精品课
      live.randomRecommend(data).then(res => {
        let resp = res.data.data;
        if (resp.jppxCourse) {
          this.payFlag = true;
          this.payObj = resp.jppxCourse;
        }

        this.recCourseList = resp.courseList;
      });

      live.wxdetail(data).then(res => {
        let resp = res.data.data;
        // 如果直播结束 已转为录播 并且时间大于直播结束  则去录播
        if (new Date().getTime() > resp.liveEndTime && resp.courseType == 0) {
          this.$router.push({
            name: 'courseDetail',
            params: { id: this.courseId }
          });
          return false;
        }
        this.categoriesArr = this.$api.categoriesFilter(resp.categories);
        this.detailObj = { ...resp, ...this.livingStore.detail };
        this.lecList = resp.lecturerList;
        window.dmsocket = new WebSocket(
          `${this.$config.webSocketPath}/ws?channel=${this.detailObj.id}`
        );
        this.hasSocket = true;
        // this.isCollection = resp.isCollection;
        this.isSignIn = resp.isSignIn;
        this.isSignUp = resp.isSignUp;
        //关联学院
        this.channelObj = resp.relationChannel;

        let customSA = {}; //神策自定义属性
        //社群 还是 分享 社群优先级高s
        if (this.$route.query.shareFlag) {
          this.scType = 'share';
        }

        if (this.$route.query.shequn) {
          this.scType = 'shequn';
        }
        if (sourceFrom == 'yabao' && this.$route.query.source_user_id) {
          // 如果是亚宝分享出来的 增加分享着ID
          customSA.source_user_id = this.$route.query.source_user_id;
        }

        let SADATA = {
          ...{
            pageUrl: location.href,
            course_id: this.courseId,
            course_name: this.detailObj.courseName,
            client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
            course_type: 'live',
            editor: this.detailObj.editorName || '',
            from: this.scType,
            web_edition: 2
          },
          ...customSA
        };
        sa.track('course_detail', SADATA, function() {});
        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.status != '0') {
              //恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '恭喜您获得3积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              //您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }
            sa.track(
              'share_total',
              {
                from: 'wx',
                type: 'live',
                target: this.courseId,
                client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
                web_edition: 2
              },
              function() {}
            );

            // 分享埋点
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: 5, // 互动主体 直播，录播，资讯，病例，站内信，论坛
              contentid: this.courseId, // 内容id
              first_cate: '', //一级分类
              second_cate: '', // 2级分类
              first_cate_id: '', // 1级分类id
              second_cate_id: '', //2级分类id
              author: this.detailObj.editorName || '', //讲师/作者
              contentname: this.detailObj.courseName,
              zone_name: this.$route.query.source_user_id
                ? ''
                : this.zone_name || '', // 来源专区
              zone_id: this.$route.query.source_user_id
                ? ''
                : this.$route.query.zone_id || '', // 来源专区
              source_user_id: this.$route.query.source_user_id || '' // 邀请人ID
              // location:'', //位置 站内，专区内，超级面对面内
            });
          });
        };
        let shareUrl = this.$api.infoWxShareUrl();
        if (isShequn) {
          shareUrl = shareUrl.split('?')[0];
        }
        if (!isShare) {
          let { zone_id, source_user_id } = this.$route.query;
          if (zone_id && !source_user_id) {
            shareUrl = `${shareUrl}${this.$api.prefixQuery(
              shareUrl
            )}source_user_id=${this.wxUserInfo.shenceId}&shareFlag=true`;
          } else {
            shareUrl = `${shareUrl}${this.$api.prefixQuery(
              shareUrl
            )}shareFlag=true`;
          }
        }
        if (this.$route.query.zone_id) {
          getChannelById({
            channelId: this.$route.query.zone_id
          }).then(res => {
            this.zone_name = res.data.data;
            // this.$wxShareInfo(
            //   this.detailObj.courseName,
            //   this.detailObj.courseName,
            //   this.detailObj.coverPic,
            //   location.href,
            //   shareUrl,
            //   shareCallBackFunc
            // );
          });
        } else {
          // this.$wxShareInfo(
          //   this.detailObj.courseName,
          //   this.detailObj.courseName,
          //   this.detailObj.coverPic,
          //   location.href,
          //   shareUrl,
          //   shareCallBackFunc
          // );
        }
        /*
         * socket
         * */
        this.detailTime2();
        this.loopLiveInter = setInterval(() => {
          this.detailTime();
        }, 10 * 1000);
      });
    }
  },
  computed: {
    ...mapState({
      closeGiftBox: state => state.closeGiftBox,
      wxUserInfo: state => state.wxUserInfo
    }),
    courseId() {
      return +this.$route.params.id;
    },
    showPayRec() {
      // 需要隐藏的推荐精品课与推荐课程
      const hideIds = [
        11510,
        11475,
        11471,
        11476,
        11472,
        11468,
        11477,
        11473,
        11469,
        11480,
        11478,
        11479,
        11474
      ];
      return !hideIds.includes(this.courseId);
    }
  },
  components: {
    CourseDocterInfo,
    RelationZone,
    payCourse,
    recCourse,
    CourseSign
  },
  filters: {
    time: function(val) {
      return dateFormat(val, 'YYYY-MM-DD HH:mm:ss');
    }
  },
  watch: {},
  created() {
    this.getDetail();
    let that = this;
    let countRest = setInterval(() => {
      if (that.restTime > 60) {
        clearInterval(countRest);
      } else {
        that.restTime += 1;
      }
    }, 1000);
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.loopLiveInter);
    try {
      window.dmsocket.close();
    } catch (e) {}
  }
};
</script>
<style lang="scss" scoped>
.fixTop {
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 2008;
  width: 100%;
  // height: 6.8rem;
  background: #fff;
}
.title {
  font-size: 0.4266rem;
  // margin-top: 0.4rem;
  width: 7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hasPadding {
  // margin-top: 7.2rem;
  overflow-y: scroll;
}
.beHasPadding {
  margin-top: 0.4rem !important;
}
.tabBox {
  width: 9.28rem;
  margin: auto;
  padding-top: 0.4rem;
  background: #fff;
}
.signBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #ebebeb;
  padding-top: 0.32rem;
}
.signIn {
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
  span {
    font-size: 0.24rem;
  }
}
.signUp {
  width: 9.2rem;
  height: 1.17rem;
  position: fixed;
  // padding-left: 6%;
  // padding-right: 6%;
  bottom: 0.4rem;
  background: #027cfa;
  text-align: center;
  color: #fff;
  text-align: center;
  line-height: 1.17rem;
}

.signup_cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  display: block;
  z-index: 9999;
  .hinew_div {
    width: 8rem;
    height: 9.28rem;
    background: url(//cdn.yxvzb.com/img/course/Group2.png) no-repeat;
    background-size: 100%;
    position: absolute;
    top: 20%;
    left: 50%;
    margin-left: -4rem;
    font-size: 0.4rem;
    padding-top: 0.5rem;
    h3 {
      font-size: 0.5866rem;
      text-align: center;
    }
    .hnp {
      margin: 0.45rem auto;
    }
    img {
      width: 4rem;
      height: 4rem;
      display: block;
      margin: auto;
    }
    p {
      width: 4.6666rem;
      text-align: center;
    }
    .hnpl {
      margin: auto;
      margin-top: 0.65rem;
      color: #027cfa;
      text-align: center;
    }
  }
  .load {
    width: 2.1066rem;
    height: 0.9066rem;
    border: 1px solid #027cfa;
    line-height: 0.9066rem;
    color: #027cfa;
    font-size: 0.4rem;
    font-weight: 100;
    margin: auto;
    margin-top: 0.2666rem;
    border-radius: 0.08rem;
  }
}
.signup_cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
}
.sc_div {
  width: 8rem;
  height: 8.88rem;
  background: url(//cdn.yxvzb.com/img/course/Rectan1.png) no-repeat;
  background-size: 100%;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -4rem;
  padding-top: 0.8rem;
  text-align: center;
  h1 {
    font-size: 0.426667rem;
    width: 3rem;
    margin: auto;
    font-weight: normal;
    color: #161616;
  }
  p {
    font-size: 0.4rem;
    width: 5.7rem;
    margin: auto;
    text-align: left;
  }
  .sc_p {
    margin: 0.7333rem auto;
  }
  .ikbt {
    width: 5.1333rem;
    height: 1.1733rem;
    border-radius: 0.08rem;
    background: #027cfa;
    margin: auto;
    color: #fff;
    text-align: center;
    font-size: 0.4rem;
    line-height: 1.1733rem;
    margin-top: 0.8rem;
  }

  .sc_pb {
    position: relative;
  }

  .sc_pb:before {
    content: '';
    position: absolute;
    top: 0.3rem;
    left: -0.3rem;
    width: 0.15rem;
    height: 0.15rem;
    border-radius: 50%;
    background: #027af6;
  }
}
.sc_div:before {
  content: '';
  width: 3.6rem;
  height: 2.6666rem;
  background: url(//cdn.yxvzb.com/img/course/Grou2.png) no-repeat;
  background-size: 100%;
  position: absolute;
  right: -1.3rem;
  top: -1.1rem;
}
.already {
  background: #d9d9d9;
  color: #333;
  border-radius: 0.11rem;
}
</style>
